import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import "./AboutASG.css"; 
import "./PAS.css"

function PAS() {
  const [, setInView] = useState(false);  
  const aboutasgSectionRef = useRef(null);
  const timeoutRef = useRef(null);

  useEffect(() => {
    const debounce = (func, wait) => {
      let timeout;
      return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
      };
    };

    const handleScroll = () => {
      if (aboutasgSectionRef.current) {
        const rect = aboutasgSectionRef.current.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) {
          setInView(true);
          timeoutRef.current = setTimeout(() => {
            if (aboutasgSectionRef.current) {
              aboutasgSectionRef.current.classList.add("done");
            }
          }, 2000);
        } else {
          setInView(false);
          if (aboutasgSectionRef.current) {
            aboutasgSectionRef.current.classList.remove("done");
          }
        }
      }
    };

    const debouncedHandleScroll = debounce(handleScroll, 100);

    window.addEventListener("scroll", debouncedHandleScroll);
    return () => {
      window.removeEventListener("scroll", debouncedHandleScroll);
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [setInView]);  

  const handleDownloadASP = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You are about to download the ASP Application Form.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, download it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const link = document.createElement("a");
        link.href = "/files/ASP_License_Form-v2.pdf"; 
        link.download = "ASP_License_Form-v2.pdf"; 
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    });
  };
  
  const handleDownloadNIC = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You are about to download the NIC Directive.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, download it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const link = document.createElement("a");
        link.href = "/files/NIC_CIRCULAR_APPROVAL OF ACTUARY.pdf"; 
        link.download = "NIC_CIRCULAR_APPROVAL OF ACTUARY.pdf"; 
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    });
  };
  
  return (
    <div className="about-asg">
      <section className="section-aboutasg" ref={aboutasgSectionRef}>
        <div className="sectiontop-line"></div>
        <h2 className="sectiontitle">PAS (LICENSES)</h2>
        <div className="sectionbottom-line"></div>
      </section>
      <div className="main-container">
        <section className="university-section">
          <div className="content">
            <h3>Principal Actuary’s Stamp (PAS)</h3>
            <p>
              The Actuarial Society of Ghana (ASG) as part of efforts to preserve 
              the integrity of the profession as mandated by the International Actuarial Association
              (IAA) since January 2023 issues the Principal Actuary’s Stamp (PAS) 
              for its Fully Qualified Actuaries (FQAs) who serve as principal actuaries 
              for companies and consulting outfits for purposes of signing off on all 
              statutory and auxiliary actuarial works in Ghana. The scope of these 
              actuarial works reserved for FQAs includes but not limited to: 
            </p>
            <ul className="list-style">
              <li>IFRS 17 Assignments</li>
              <li>Actuarial Valuation</li>
              <li>Financial Condition Reports (FCR)</li>
              <li>Actuarial Memorandum (Product Design & Pricing)</li>
              <li>Actuarial Audit and Peer Review</li>
              <li>Employee Benefits Valuation under IAS 19 etc</li>
            </ul>
            <p>
              It is important to note that the <b>ASG PAS</b> are only issued to FQAs through a 
              registered and approved <b>Institutional member or Actuarial Service Provider (ASP).</b>
            </p>
            <p>
              Holding an <b>ASG PAS</b> is therefore an evidence of recognition by the ASG for a 
              company and its principal Actuary(ies) for an Appointed Actuary or external 
              Actuary role for players under the National Insurance Commission (NIC), 
              National Health Insurance Authority (NHIA) and National Pensions Regulatory 
              Authority (NPRA).
            </p>
            <p>
              List of Principal Actuary’s with stamps and their companies will be 
              published here and on the websites of the regulators annually.
            </p>

            <h3>Institutional Membership/Actuarial Service Provider (ASP) License</h3>
            <p>
              In furtherance of <b>Section (7) of the ASG Constitution</b> for regulation and 
              affiliation purposes, the Actuarial Society of Ghana (ASG) provides 
              Actuarial Service Provider (ASP) Licensing under institutional membership.
            </p>
            <p>
              The scope of Actuarial Service Providers includes:
            </p>
            <ul className="list-style">
              <li>Consulting firms (local and international) operating in Ghana</li>
              <li>Multinational companies (insurers and trustees) with non-resident group-level Actuaries.</li>
              <li>Independent individual Actuaries (operating under a registered business name as sole proprietorship)</li>
            </ul>
            <p>
              Institutional Membership or Actuarial Service Provider (ASP) Licenses are 
              renewable every 2 years.
            </p>
            <p>
              Refer to <b>Institutional Membership Application form</b> for further details on 
              documents required.
            </p>
          </div>
        </section>

        <section className="card-section" style={{ marginTop: "10px" }}>
            <div className="accreditation-card" onClick={handleDownloadASP} style={{ cursor: "pointer" }}>
                <h2 className="uni-title">ASP Application Form</h2>
            </div>
            <div className="accreditation-card" onClick={handleDownloadNIC} style={{ cursor: "pointer" }}>
                <h2 className="uni-title">NIC Directive</h2>
            </div>
          <Link to="/principalactuaries">
            <div className="accreditation-card">
              <h2 className="uni-title">List of Principal Actuaries</h2>
            </div>
          </Link>
        </section>
      </div>
    </div>
  );
}

export default PAS;
